
import Vue, { PropType } from 'vue';
import { Theme } from '@/side-bar/side-bar-config.interface';

interface SideBarNotificationConfig {
    title:string,
    subtitle:string,
    buttonText:string
}

export default Vue.extend({
    name: 'SideBarNotification',

    props: {
        config: {
            type: Object as PropType<SideBarNotificationConfig>,
            required: true
        },
        theme: {
            type: Object as PropType<Theme>,
            default: () => ({})
        }
    }
});
